import { MapContainer, TileLayer, GeoJSON, useMap } from "react-leaflet";

import axios from "axios";

import { useState, useEffect } from "react";

import "leaflet/dist/leaflet.css";

import "leaflet-defaulticon-compatibility";

import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";

import L from "leaflet";

import MarkerClusterGroup from "react-leaflet-markercluster";

import "leaflet.markercluster/dist/MarkerCluster.Default.css";

import "leaflet.markercluster/dist/MarkerCluster.css";

import "./App.css";

import * as turf from "@turf/turf";

 
 
// --------------------------------------------------

// LISTEN FOR ROLE ID SENT FROM MEDADASHBOARD

// --------------------------------------------------

window.addEventListener("message", function (event) {

  if (event.origin !== "https://medadashboard.idaminfra.com") return;
 
  if (event.data.type === "SET_ROLE_ID") {

    window.parentUserId = event.data.roleId;   // store globally

    console.log("React received role ID:", window.parentUserId);

  }

});
 
 
// --------------------------------------------------

// MAP FIT TO MAHARASHTRA

// --------------------------------------------------

function FitBoundsToMaharashtra({ data }) {

  const map = useMap();
 
  useEffect(() => {

    if (data) {

      const layer = L.geoJSON(data);

      map.fitBounds(layer.getBounds());

    }

  }, [data]);
 
  return null;

}
 
 
// Utility to randomize polygon color

function getRandomHex() {

  return "#" + Math.floor(Math.random() * 16777215).toString(16);

}
 
 
// --------------------------------------------------

// MAIN APP COMPONENT

// --------------------------------------------------

function App() {

  const [geoData, setGeoData] = useState(null);

  const [mahaBorder, setMahaBorder] = useState(null);

  const [districts, setDistricts] = useState(null);

  const [layerKey, setLayerKey] = useState(0);
 
  const [userId, setUserId] = useState(window.parentUserId || null); // <- Role ID from parent
 
  const API_BASE = `${window.location.origin}/api`;

 
  const [mahaPolygon, setMahaPolygon] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isThemeLoading, setIsThemeLoading] = useState(false);
 

 
  // --------------------------------------------------

  // WAIT UNTIL postMessage PROVIDES roleId

  // --------------------------------------------------

useEffect(() => {
  const handler = (event) => {
    if (event.origin !== "https://medadashboard.idaminfra.com") return;

    if (event.data.type === "SET_ROLE_ID") {
      setUserId(event.data.roleId);
      window.parentUserId = event.data.roleId; // persist
    }
  };

  window.addEventListener("message", handler);

  return () => window.removeEventListener("message", handler);
}, []);

 
 
  // --------------------------------------------------

  // USER UPLOAD PERMISSION CONTROL

  // --------------------------------------------------

  const allowedUsers = [2, 3, 4, 5, 6, 7, 8, 9, 10,11];

  const canUpload = userId !== null && allowedUsers.includes(Number(userId));

 
 
  // --------------------------------------------------

  // LOAD MAHARASHTRA BORDER

  // --------------------------------------------------

useEffect(() => {
  fetch("/maharashtra.geojson")
    .then((res) => res.json())
    .then((data) => {
      setMahaBorder(data);

      let merged = data.features[0];

      for (let i = 1; i < data.features.length; i++) {
        merged = turf.union(merged, data.features[i]);
      }

      setMahaPolygon(merged);
    })
    .catch((err) => console.error("Maharashtra GeoJSON error:", err));
}, []);


 
 
  // --------------------------------------------------

  // FILE UPLOAD HANDLER

  // --------------------------------------------------

  const filterPointsInsideMaharashtra = (geojson) => {
  if (!mahaPolygon || !geojson || !geojson.features) return geojson;

  const filteredFeatures = geojson.features.filter((feature) => {
    if (!feature.geometry || feature.geometry.type !== "Point") return false;

    const point = turf.point(feature.geometry.coordinates);
    return turf.booleanPointInPolygon(point, mahaPolygon);
  });

  return {
    type: "FeatureCollection",
    features: filteredFeatures
  };
};

const handleFileSelect = (event) => {
  const file = event.target.files[0];
  if (file) {
    setSelectedFile(file);
  }
};

const handleSubmitUpload = async () => {
  if (!userId) {
    alert("Role ID not received yet.");
    return;
  }

  if (!selectedFile) {
    alert("Please select a file first.");
    return;
  }

  const formData = new FormData();
  formData.append("file", selectedFile);
  formData.append("user_id", userId);

  try {
    setIsUploading(true);

    const res = await axios.post(`${API_BASE}/upload-csv`, formData);
    const geojsonUrl = API_BASE + res.data.geojson_url;

    const geojsonData = await axios.get(geojsonUrl);

    const filtered = filterPointsInsideMaharashtra(geojsonData.data);
    setGeoData(filtered);
    setLayerKey((prev) => prev + 1);

    setSelectedFile(null); // reset after success

  } catch (err) {
    console.error(err);

    if (err.response && err.response.data) {
      const data = err.response.data;

      if (data.errors && Array.isArray(data.errors)) {
        const errorMessage =
          `${data.message}\n\n` +
          data.errors
            .slice(0, 5)
            .map(e => `Row ${e.row}: ${e.error}`)
            .join("\n");

        alert(errorMessage);

      } else if (data.error) {
        alert(data.error);
      } else {
        alert("Upload failed due to invalid data.");
      }

    } else {
      alert("Upload failed. Please try again.");
    }

    setSelectedFile(null); // reset after failure

  } finally {
    setIsUploading(false);
  }
};


 
 
  // --------------------------------------------------

  // LOAD EXISTING THEMES

  // --------------------------------------------------

  const [uploadedFiles, setUploadedFiles] = useState([]);

  const DEFAULT_THEME = "Cogeneration Project.csv";
  const [selectedTheme, setSelectedTheme] = useState(DEFAULT_THEME);
 
useEffect(() => {
  axios
    .get(`${API_BASE}/list-uploads`)
    .then(async (res) => {
      setUploadedFiles(res.data.files);

      // Auto-load Cogeneration Project if present
      if (res.data.files.includes(DEFAULT_THEME)) {
        setSelectedTheme(DEFAULT_THEME);

        const geojsonFilename = DEFAULT_THEME.replace(".csv", ".geojson");
        const response = await axios.get(
          `${API_BASE}/geojson/${geojsonFilename}`
        );

        const filtered = filterPointsInsideMaharashtra(response.data);
        setGeoData(filtered);
        setLayerKey((prev) => prev + 1);
      }
    })
    .catch((err) => console.error("Error loading uploads:", err));
}, [mahaPolygon]);   // 👈 depends on polygon

 
 
  const handleThemeChange = async (event) => {
  const csvFilename = event.target.value;
  setSelectedTheme(csvFilename);

  if (!csvFilename) return;

  setIsThemeLoading(true);

  const geojsonFilename = csvFilename.replace(".csv", ".geojson");

  try {
    const response = await axios.get(`${API_BASE}/geojson/${geojsonFilename}`);

    const filtered = filterPointsInsideMaharashtra(response.data);
    setGeoData(filtered);
    setLayerKey((prev) => prev + 1);

  } catch (err) {
    console.error(err);
    alert("GeoJSON not found. Upload CSV file first.");
  } finally {
    setIsThemeLoading(false);
  }
};

 
  // --------------------------------------------------

  // POPUP HANDLER

  // --------------------------------------------------

// --------------------------------------------------
// POPUP HANDLER (FIXED)
// --------------------------------------------------
// --------------------------------------------------
// POPUP HANDLER (FINAL – TABLE SAFE)
// --------------------------------------------------
// --------------------------------------------------
// POPUP HANDLER (FINAL – NO LETTER STACKING)
// --------------------------------------------------
const onEachFeature = (feature, layer) => {

  let html = `
<div style="
  font-family: Arial, sans-serif;
  font-size: 13px;
  min-width: 360px;
  max-width: 420px;
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
">
  <div style="
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 6px;
  ">
    Details
  </div>

  <table style="
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
  ">
`;

  for (let key in feature.properties) {
    const label = key.replace(/_/g, " ");
    const value = feature.properties[key] ?? "—";

    html += `
<tr>
  <td style="
    border: 1px solid #e0e0e0;
    padding: 6px;
    width: 40%;
    font-weight: 600;
    vertical-align: top;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    background: #f7f7f7;
  ">
    ${label}
  </td>

  <td style="
    border: 1px solid #e0e0e0;
    padding: 6px;
    width: 60%;
    vertical-align: top;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
  ">
    ${value}
  </td>
</tr>`;
  }

  html += `
  </table>
</div>
`;

  layer.bindPopup(html, {
    maxWidth: 450,
    minWidth: 360,
    autoPan: true,
    closeButton: true
  });
};


 
 
  // --------------------------------------------------

  // LOAD DISTRICTS

  // --------------------------------------------------

  useEffect(() => {

    fetch("/maharashtra2.geojson")

      .then((res) => res.json())

      .then((data) => setDistricts(data));

  }, []);
 
 
  // --------------------------------------------------

  // RENDER APP UI

  // --------------------------------------------------

  return (
<div>
 
      {/* THEME DROPDOWN */}
<div className="theme-dropdown">
<select

          value={selectedTheme}

          onChange={handleThemeChange}

          style={{

            width: "100%",

            padding: "6px 8px",

            borderRadius: "5px",

            border: "1px solid #ccc"

          }}
>
<option value="">-- Choose Theme --</option>
 
          {uploadedFiles.length > 0 ? (

            uploadedFiles.map((file) => (
<option key={file} value={file}>

                {file.replace(".csv", "").replace(/_/g, " ")}
</option>

            ))

          ) : (
<option disabled>No themes found</option>

          )}
</select>
</div>
 
 {isThemeLoading && (
  <div style={{
    marginTop: "6px",
    fontSize: "13px",
    color: "#1976d2"
  }}>
    Loading theme on map…
  </div>
)}

 
    
      {/* FILE UPLOAD (ONLY FOR ALLOWED USERS) */}

      {canUpload && (
  <div className="upload-box" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    
{/* Select File (Custom Button) */}
<label
  style={{
    padding: "6px 12px",
    backgroundColor: "#e0e0e0",
    borderRadius: "4px",
    cursor: "pointer",
    border: "1px solid #ccc"
  }}
>
  Choose File
  <input
    type="file"
    accept=".csv"
    onChange={handleFileSelect}
    style={{ display: "none" }}
  />
</label>


    {/* Selected file name */}
    {selectedFile && (
      <span style={{ fontSize: "13px", color: "#333" }}>
        {selectedFile.name}
      </span>
    )}

    {selectedFile && !isUploading && (
  <div style={{ fontSize: "12px", color: "#555" }}>
    File selected. Click <b>Submit</b> to upload and view on map.
  </div>
)}


    {/* Submit button */}
    <button
      onClick={handleSubmitUpload}
      disabled={isUploading}
      style={{
        padding: "6px 12px",
        backgroundColor: "#1976d2",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: isUploading ? "not-allowed" : "pointer"
      }}
    >
      {isUploading ? "Uploading..." : "Submit"}
    </button>
  </div>
)}

 
 
      {/* MAP SECTION */}
<MapContainer

        center={[19.7515, 75.7139]}

        zoom={7.4}

        style={{ height: "100vh", width: "100%" }}
>
<TileLayer
  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
/>

 
        {mahaBorder && <GeoJSON data={mahaBorder} style={{ color: "#333", weight: 1.2 }} />}
 
        {districts && (
<GeoJSON

            data={districts}

            style={() => ({

              color: "#333",

              weight: 1,

              fillColor: getRandomHex(),

              fillOpacity: 0.2,

            })}

            onEachFeature={(feature, layer) => {

              layer.bindPopup("<b>District:</b> " + (feature.properties.DISTRICT || "Unknown"));

            }}

          />

        )}
 
        {geoData && (
<MarkerClusterGroup key={layerKey}>
<GeoJSON

              data={geoData}

              onEachFeature={onEachFeature}

              pointToLayer={(f, latlng) => L.marker(latlng)}

            />
</MarkerClusterGroup>

        )}
</MapContainer>
</div>

  );

}
 
export default App;

 